import React from 'react';
import PropTypes from 'prop-types';

import './AlarmClockIcon.scss';

const AlarmClockIcon = ({ isActive }) => {
    const activeStyle = isActive ? 'active' : '';
    return (
        <svg
            className={`component-AlarmClockIcon ${activeStyle}`}
            fill="none"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                className="outline"
                d="M10.5416 7.33313C10.5416 6.82696 10.9485 6.41664 11.4583 6.41664C11.9645 6.41664 12.3749 6.82338 12.3749 7.33313V11C12.3749 11.5062 11.9685 11.9166 11.4591 11.9166H9.62405C9.11827 11.9166 8.70825 11.5098 8.70825 11C8.70825 10.4937 9.11466 10.0833 9.62405 10.0833H10.5416V7.33313ZM15.3322 17.2276C14.2081 17.9284 12.8804 18.3333 11.4582 18.3333C10.0359 18.3333 8.70824 17.9284 7.5841 17.2276L6.75159 18.6696C6.4987 19.1076 5.94133 19.2592 5.49984 19.0043C5.0614 18.7512 4.90918 18.194 5.16388 17.7529C5.16388 17.7529 6.1256 16.0928 6.15061 16.0604C4.89548 14.7443 4.12484 12.9621 4.12484 11C4.12484 9.90781 4.36358 8.87142 4.79174 7.94014C4.10307 7.35169 3.6665 6.47681 3.6665 5.49996C3.6665 3.72805 5.10292 2.29163 6.87484 2.29163C8.06037 2.29163 9.09572 2.93464 9.65114 3.89094C10.2292 3.74446 10.8346 3.66663 11.4582 3.66663C12.022 3.66663 12.571 3.73026 13.0984 3.85075C13.6592 2.91667 14.6821 2.29163 15.8509 2.29163C17.6228 2.29163 19.0593 3.72805 19.0593 5.49996C19.0593 6.412 18.6787 7.23516 18.0677 7.8193C18.5315 8.78143 18.7915 9.86034 18.7915 11C18.7915 12.9621 18.0209 14.7443 16.7657 16.0604C16.7907 16.0928 17.7525 17.7529 17.7525 17.7529C18.0072 18.194 17.8549 18.7512 17.4165 19.0043C16.975 19.2592 16.4176 19.1076 16.1647 18.6696L15.3322 17.2276ZM6.87488 4.12497C6.11549 4.12497 5.49988 4.74058 5.49988 5.49997C5.49988 5.81558 5.60726 6.11064 5.79064 6.34599C6.37547 5.63462 7.09162 5.03529 7.90202 4.58507C7.64726 4.29967 7.27755 4.12497 6.87488 4.12497ZM17.2259 5.49997C17.2259 4.74058 16.6103 4.12497 15.8509 4.12497C15.4814 4.12497 15.1396 4.27212 14.8889 4.51696C15.7028 4.94856 16.4257 5.52895 17.0214 6.22187C17.1518 6.01042 17.2259 5.76229 17.2259 5.49997ZM5.95825 11C5.95825 14.0375 8.42069 16.5 11.4583 16.5C14.4958 16.5 16.9583 14.0375 16.9583 11C16.9583 7.9624 14.4958 5.49997 11.4583 5.49997C8.42069 5.49997 5.95825 7.9624 5.95825 11Z"
            />
            <path
                className="clock-body"
                d="M5 4H8V5.80269C8.88252 5.29218 9.90714 5 11 5C12.0929 5 13.1175 5.29218 14 5.80269V4H18V7H15.4722C16.4223 8.06151 17 9.46329 17 11C17 14.3137 14.3137 17 11 17C7.68629 17 5 14.3137 5 11C5 9.46329 5.57771 8.06151 6.52779 7H5V4Z"
            />
            <rect
                className="clock-hand"
                x="11"
                y="7"
                width="2"
                height="5"
                rx="1"
            />
            <rect
                className="clock-hand"
                x="9"
                y="10"
                width="4"
                height="2"
                rx="1"
            />
        </svg>
    );
};

AlarmClockIcon.propTypes = {
    isActive: PropTypes.bool,
};

AlarmClockIcon.defaultProps = {
    isActive: false,
};

AlarmClockIcon.displayName = 'AlarmClockIcon';

export default AlarmClockIcon;
